import { createUseStyles } from 'react-jss';

import { AbsoluteWhiteColors } from '@picsart/design-system/foundation/colors';
import { Effects } from '@picsart/design-system/foundation/effects';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';

const useStyles = createUseStyles(
  {
    media: {
      position: 'absolute',
      inset: 0,
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
    poster: {
      position: 'absolute',
      inset: 0,
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      pointerEvents: 'none',
    },
    videoTapLayer: {
      position: 'relative',
      display: 'block',
      width: '100%',
      height: '100%',
      padding: 0,
      border: 'none',
      background: 'transparent',
      cursor: 'pointer',
    },
    playIndicator: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: Spacings.s64,
      height: Spacings.s64,
      borderRadius: CornerRadius.circle,
      backgroundColor: Effects.alpha50,
      color: AbsoluteWhiteColors.base.default,
      pointerEvents: 'none',
    },
  },
  { name: 'feed-slide-media' }
);

export default useStyles;
